import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/CourseCard.css";
import { 
  FaGraduationCap, 
  FaBriefcase, 
  FaCalculator, 
  FaIndustry, 
  FaLaptopCode, 
  FaSeedling, 
  FaLandmark, 
  FaHeartbeat, 
  FaChartLine, 
  FaUserTie 
} from "react-icons/fa";

const CourseCard = () => {
  const navigate = useNavigate();

  // Course Categories Data - All categories from Book.js
  const categories = [
    {
      id: 1,
      name: "K12",
      title: "K-12 Education",
      description: "Complete school curriculum from Kindergarten to Class 12",
      icon: <FaGraduationCap />,
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)",
      stats: "Mathematics, Science, English & More"
    },
    {
      id: 2,
      name: "Mathematics",
      title: "Mathematics",
      description: "Advanced mathematical concepts and problem solving",
      icon: <FaCalculator />,
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
      stats: "Algebra, Calculus, Geometry & More"
    },
    {
      id: 3,
      name: "Vocational",
      title: "Vocational Training",
      description: "Practical skills and job-oriented training programs",
      icon: <FaBriefcase />,
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      stats: "Industry-Ready Skills & Certifications"
    },
    {
      id: 4,
      name: "Industry",
      title: "Industry",
      description: "Industrial training and manufacturing knowledge",
      icon: <FaIndustry />,
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      stats: "Manufacturing, Production & Quality"
    },
    {
      id: 5,
      name: "Technology",
      title: "Technology",
      description: "Latest technology trends and programming skills",
      icon: <FaLaptopCode />,
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      stats: "Coding, AI, Cloud & More"
    },
    {
      id: 6,
      name: "Agriculture",
      title: "Agriculture",
      description: "Modern farming techniques and agricultural science",
      icon: <FaSeedling />,
      color: "#84cc16",
      gradient: "linear-gradient(135deg, #84cc16 0%, #65a30d 100%)",
      stats: "Farming, Sustainability & Innovation"
    },
    {
      id: 7,
      name: "UPSC",
      title: "UPSC",
      description: "Comprehensive preparation for civil services examination",
      icon: <FaLandmark />,
      color: "#dc2626",
      gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
      stats: "IAS, IPS, IFS & Other Services"
    },
    {
      id: 8,
      name: "Medical",
      title: "Medical",
      description: "Medical education and healthcare knowledge",
      icon: <FaHeartbeat />,
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      stats: "Medicine, Healthcare & Wellness"
    },
    {
      id: 9,
      name: "Management",
      title: "Management",
      description: "Business management and organizational skills",
      icon: <FaChartLine />,
      color: "#6366f1",
      gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
      stats: "MBA, Strategy & Operations"
    },
    {
      id: 10,
      name: "Leadership",
      title: "Leadership",
      description: "Leadership development and team management",
      icon: <FaUserTie />,
      color: "#ec4899",
      gradient: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
      stats: "Team Building, Communication & Vision"
    }
  ];

  // Handle category card click
  const handleCategoryClick = (categoryName) => {
    console.log("=== CATEGORY CARD CLICKED ===");
    console.log("Category:", categoryName);
    console.log("Redirecting to /CoursePage");
    
    // Simple redirect without any params
    navigate("/CoursePage");
  };

  return (
    <div className="course-card-page">
      {/* Category Cards Grid */}
      <div className="category-cards-section">
        <div className="category-cards-container">
          <div className="category-cards-grid">
            {categories.map((category, index) => (
              <div
                key={category.id}
                className="category-card"
                onClick={() => handleCategoryClick(category.name)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Card Background Gradient */}
                <div 
                  className="card-gradient-bg"
                  style={{ background: category.gradient }}
                ></div>

                {/* Card Content */}
                <div className="card-content">
                  {/* Icon Section */}
                  <div 
                    className="category-icon"
                    style={{ color: category.color }}
                  >
                    {category.icon}
                  </div>

                  {/* Text Content */}
                  <div className="category-text">
                    <h2 className="category-title">{category.title}</h2>
                    <p className="category-description">{category.description}</p>
                  </div>
                </div>

                {/* Decorative Elements */}
                <div className="card-decoration">
                  <div className="decoration-circle decoration-circle-1"></div>
                  <div className="decoration-circle decoration-circle-2"></div>
                  <div className="decoration-circle decoration-circle-3"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;